export enum SortingType {
    BEST_MATCH = 'best_match',
    PLACED_TIME = 'placed_time',
    COUNTDOWN = 'countdown'
}
